var exports = {
  "Mx": "PageLayout__tNk40o",
  "Zv": "Pane__1K_yoT",
  "UC": "Content__N1Ma51",
};

module.exports = exports;
